import { area as P } from './useData'

export const area = P

export default async (
  data: any,
  map = { area: 'areaName', city: 'cityName' } as any
): Promise<any> => {
  const [area, city] = Object.keys(map)
  const [areaName, cityName] = Object.values(map)
  const result: any = [[], []]
  const prov1inces = await P
  result[0] = prov1inces
  if (data[area]) {
    const p: any = prov1inces.find((v2: any) => v2.intAreaId === data[area])
    if (p) {
      data[areaName] = p.label
      result[1] = p.children
      if (data[city]) {
        data[cityName] = result[1].find(
          (v2: any) => v2.intAreaId === data[city]
        )?.label
      }
    }
  }
  return result
}
